import Swiper from 'swiper';
import { Navigation, Pagination, Autoplay, A11y } from 'swiper/modules';

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.logos-carousel-swiper').forEach((element) => {
    const getConfiguredValueForWidth = (swiper, paramName) => {
      const width = window.innerWidth;
      let value = swiper.passedParams[paramName];
      let matched = 0;
      const breakpoints = swiper.passedParams.breakpoints || {};
      Object.keys(breakpoints).forEach(bp => {
        const bpNum = parseInt(bp, 10);
        if (width >= bpNum && bpNum > matched) {
          matched = bpNum;
          if (breakpoints[bp][paramName] !== undefined) {
            value = breakpoints[bp][paramName];
          }
        }
      });
      return value;
    }

    const swiperItemsCalc = (swiper) => {
      const container = swiper.el.closest('section');
      const containerGap = parseInt(getComputedStyle(container).getPropertyValue('column-gap'));
      const swiperWidth = (container.offsetWidth - containerGap) / 2; 
      const correctWidth = swiper.el.parentNode.querySelector('.swiper-controls, .swiper-sizer')?.offsetWidth;
      const items = getConfiguredValueForWidth(swiper, 'slidesPerView');
      const itemWidth = correctWidth / items;
      const slides = Math.floor(swiperWidth / itemWidth) + 1;
      const newSwiperWidth = slides * itemWidth;
      swiper.el.style.width = newSwiperWidth + 'px';
      swiper.params.slidesPerView = slides;
      swiper.update();
      return slides;
    }

    const cloneSlides = (swiper, visibleSlides = 10) => {
      const wrapper = swiper.el.querySelector('.swiper-wrapper');
      const slides = Array.from(wrapper.children);
      
      if (slides.length > visibleSlides) return;

      const minimumQuantityToClone = visibleSlides - slides.length;
      let cloneCount = 0;

      do{
        for (let i = 0; i < slides.length; i++) {
          const clone = slides[i].cloneNode(true);
          clone.classList.add('swiper-slide-duplicate');
          wrapper.appendChild(clone);
          cloneCount++;
        }
      }while(cloneCount < minimumQuantityToClone);
    }

    new Swiper(element, {
      modules: [Navigation, Pagination, Autoplay, A11y],
      slidesPerView: "auto",
      simulateTouch: false,
      watchOverflow: false,
      centeredSlides: false,
      centerInsufficientSlides: true,
      navigation: {
        enabled: element.dataset.navigation == '1',
        prevEl: element.closest('.swiper-parent').querySelector('.swiper-navigation .prev'),
        nextEl: element.closest('.swiper-parent').querySelector('.swiper-navigation .next'),
      },
      loop: element.dataset.loop == '1',
      autoplay: element.dataset.autoplay == '1'
        ? {
            delay: parseFloat(element.dataset.autoplayDelay) * 1000,
          }
        : false,
      on: {
        beforeInit: (swiper) => {
          if(element.dataset.loop == '1'){
            const visibleSlides = swiperItemsCalc(swiper);
            cloneSlides(swiper, visibleSlides);
          }
        },
      }
    });
  });
});
